"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuspenseImageSlots = exports.default = exports.SuspenseImage = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _useSuspenseImage = _interopRequireDefault(require("../useSuspenseImage"));
var _suspenseImageClasses = require("./suspenseImageClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getSuspenseImageSlots = _ => ({
  root: ['root']
});
exports.getSuspenseImageSlots = getSuspenseImageSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getSuspenseImageSlots(ownerState);
  return (0, _base.unstable_composeClasses)(slots, _suspenseImageClasses.getSuspenseImageUtilityClass, classes);
};
const SuspenseImageRoot = (0, _material.styled)('img', {
  name: 'MuiOriSuspenseImage',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})({});
const SuspenseImage = exports.SuspenseImage = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriSuspenseImage'
  });
  const {
    component,
    src,
    srcSet,
    className,
    shouldThrowError,
    errorFallback = null,
    onerror,
    onload,
    ...otherProps
  } = props;
  const {
    isLoaded,
    error
  } = (0, _useSuspenseImage.default)({
    shouldThrowError,
    src,
    srcSet,
    onerror,
    onload
  });
  const ownerState = {
    ...props,
    isLoaded,
    error,
    shouldThrowError
  };
  const classes = useUtilityClasses(ownerState);
  if (error !== undefined) {
    return errorFallback;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SuspenseImageRoot, {
    ref: ref,
    as: component,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    src: src,
    srcSet: srcSet,
    ...otherProps
  });
});
var _default = exports.default = SuspenseImage;
//# sourceMappingURL=SuspenseImage.js.map